interface SpinnerProps {
  /** Duong kinh px. Mac dinh 16 de nam vua trong mot dong chu. */
  size?: number;
  label?: string;
}

export function Spinner({ size = 16, label }: SpinnerProps) {
  return (
    <span className="inline-flex items-center gap-2 text-slate-500 dark:text-slate-400">
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        role="img"
        aria-label={label ?? 'Đang tải'}
        className="animate-spin"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="3" opacity="0.25" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      {label !== undefined && <span className="text-sm">{label}</span>}
    </span>
  );
}
